<template>
  <div>
    <v-dialog
      v-if="!isMobile"
      content-class="custom-dialog"
      v-model="isOpen"
      :persistent="true"
    >
      <v-card>
        <div class="cost-container">
          <img
            class="close-icon"
            src="../../assets/images/cross-icon.webp"
            alt="Schließen-Symbol"
            @click="cancel()"
          />
          <div class="cost-header">
            <img
              src="../../assets/images/info-icon.webp"
              width="23.12"
              height="23.12"
              alt="Info-Symbol"
            />
            Welche Kosten werden für Ihre Hilfsmittel übernommen?
          </div>
          <div class="cost-body">
            <div class="c-description">
              <div class="c-d-style">
                Grundlage für eine Kostenübernahme ist ein
                <span class="bold">gültiges Rezept.</span>
              </div>
              <div class="c-d-style">
                Welche Kosten Sie selbst tragen, hängt davon ab, ob Sie sich
                nach einer Beratung für ein
                <span class="bold">Kassenmodell</span> oder ein
                <span class="bold">höherwertiges Modell</span> Ihres
                Hilfsmittels entscheiden.*
              </div>
            </div>
            <div class="c-content">
              <div class="c-r-container">
                <div class="r-1">
                  <div class="r-1-0">
                    <div class="r-1-0-1">Ihr Anteil:</div>
                    <div class="r-1-0-2">5 - 10 €</div>
                  </div>
                  <div class="r-1-1"></div>
                  <div class="r-1-2"></div>
                </div>
                <div class="r-2">
                  <div class="r-2-1">
                    Ihre Versicherung trägt die Grundkosten,
                  </div>
                  <div class="r-2-2">
                    wenn das Hilfsmittel medizinisch notwendig ist.
                  </div>
                </div>
                <div class="r-3">
                  <div class="t-1-0">
                    <div class="t-1-0-1">Ihr Anteil:</div>
                    <div class="t-1-0-2">
                      Aufzahlung je nach Modell und Anbieter
                    </div>
                  </div>
                  <div class="r-3-1"></div>
                  <div class="r-3-2"></div>
                </div>
              </div>
              <div class="c-r-foot">
                <div class="c-r-foot-item">
                  <div class="c-r-f-1">Kassenmodell</div>
                  <div class="c-r-f-2">
                    (zum Beispiel ein Standard-Rollator)
                  </div>
                  <img src="../../assets/images/image 113.png" alt="" />
                </div>
                <div class="c-r-foot-item">
                  <div class="c-r-f-1">Höherwertiges Modell</div>
                  <div class="c-r-f-2">
                    (zum Beispiel ein Leichtgewicht-Rollator)
                  </div>
                  <img src="../../assets/images/image 115.png" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div class="c-footer">
            <div class="c-f-1">
              * Für bestimmte Situationen und Hilfsmittel gelten andere
              Regelungen für eine Kostenübernahme
            </div>
            <div class="c-f-2" @click="moreDetail">
              <p>Mehr erfahren</p>
              <img
                src="../../assets/images/arrow-right-icon.webp"
                width="20"
                height="20"
                alt=""
              />
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-bottom-sheet
      v-else
      content-class="custom-dialog"
      v-model="isOpen"
      @click:outside="cancel()"
    >
      <v-card>
        <div class="cost-container">
          <img
            class="close-icon"
            src="../../assets/images/cross-icon.webp"
            alt="Schließen-Symbol"
            @click="cancel()"
          />
          <div class="cost-header">
            <img
              src="../../assets/images/info-icon.webp"
              width="23.12"
              height="23.12"
              alt="Info-Symbol"
            />
            Welche Kosten werden für Ihre Hilfsmittel übernommen?
          </div>
          <div class="cost-body">
            <div class="c-description">
              <div class="c-d-style">
                Grundlage für eine Kostenübernahme ist ein
                <span class="bold">gültiges Rezept.</span>
              </div>
              <div class="c-d-style">
                Welche Kosten Sie selbst tragen, hängt davon ab, ob Sie sich
                nach einer Beratung für ein
                <span class="bold">Kassenmodell</span> oder ein
                <span class="bold">höherwertiges Modell</span> Ihres
                Hilfsmittels entscheiden.*
              </div>
            </div>
            <div class="c-content">
              <div class="c-r-m-d">
                <div class="c-r-m-d-1">Beispiel</div>
                <div class="c-r-m-d-2">
                  Kostenübernahme bei einem Rollator mit gültigem Rezept:
                </div>
              </div>
              <div class="c-r-container">
                <div class="r-1">
                  <div class="r-1-1">
                    <div class="r-m1-0">
                      <span class="r-m1-0-1">Ihr Anteil: </span>
                      <span class="r-m1-0-2">5 - 10 €</span>
                    </div>
                  </div>
                  <div class="r-1-2">
                    <div class="r-m2-0">
                      <span class="r-m2-0-1">Ihre </span>
                      <span class="r-m2-0-2">Versicherung</span>
                      <span class="r-m2-0-3"> trägt die Grundkosten</span>
                    </div>
                  </div>
                </div>
                <div class="r-3">
                  <div class="r-3-1">
                    <div class="r-m3-0">
                      <div class="r-m3-0-1">Ihr Anteil:</div>
                      <div class="r-m3-0-2">
                        Aufzahlung je nach Modell und Anbieter
                      </div>
                    </div>
                  </div>
                  <div class="r-3-2">
                    <div class="r-m2-0">
                      <span class="r-m2-0-1">Ihre </span>
                      <span class="r-m2-0-2">Versicherung</span>
                      <span class="r-m2-0-3"> trägt die Grundkosten</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="c-r-foot">
                <div class="c-r-foot-item">
                  <div class="c-r-f-1">Kassenmodell</div>
                  <div class="c-r-f-2">
                    (zum Beispiel ein Standard-Rollator)
                  </div>
                  <img src="../../assets/images/image 113.png" alt="" />
                </div>
                <div class="c-r-foot-item">
                  <div class="c-r-f-1">Höherwertiges Modell</div>
                  <div class="c-r-f-2">
                    (zum Beispiel ein Leichtgewicht-Rollator)
                  </div>
                  <img src="../../assets/images/image 115.png" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div class="c-footer">
            <div class="c-f-1">
              * Für bestimmte Situationen und Hilfsmittel gelten andere
              Regelungen für eine Kostenübernahme
            </div>
            <div class="c-f-2" @click="moreDetail">
              <p>Mehr erfahren</p>
              <img
                src="../../assets/images/arrow-right-icon.webp"
                width="20"
                height="20"
                alt="Pfeil nach rechts-Symbol"
              />
            </div>
          </div>
        </div>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
export default {
  name: "CostModal",
  props: {
    isOpen: Boolean,
    isMobile: Boolean,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    cancel() {
      this.$emit("closeCModal", false);
    },
    moreDetail() {
      let url =
        "https://anni.care/hilfsmittel/verordnung-von-hilfsmitteln/";
      window.open(url, "_blank", "noreferrer");
    },
  },
  mounted() {},
  updated() {},
};
</script>

<style></style>
